<template>
    <div ref="root" class="mdc-accordion__item" :data-item="itemid">
        <div class="mdc-accordion__trigger">
            <button type="button" class="mdc-accordion__trigger-button" @click="toggleAction">
        <span v-if="image" class="mdc-accordion__trigger-image">
            <NewsLabel v-if="newslabel">{{ newslabel }}</NewsLabel>
          <img :src="image" alt=""/>
        </span>
                <span class="mdc-accordion__trigger-wrap">
            <span v-if="label||sublabel" class="mdc-accordion__trigger-text">
                <span class="mdc-accordion__trigger-label">{{ label }}</span>
                <span v-if="sublabel" class="mdc-accordion__trigger-sublabel">{{ sublabel }}</span>
            </span>
            <span class="mdc-accordion__trigger-toggle" :class="state" aria-hidden="true">keyboard_arrow_down</span>
          </span>
            </button>
        </div>
        <div ref="target" class="mdc-accordion__content" :class="state">
            <div class="mdc-accordion__content-wrap">
                <slot/>
            </div>
        </div>
    </div>
</template>

<script>
import {ref, computed, getCurrentInstance, toRefs, watch} from "vue";
import waitForElementTransition from "wait-for-element-transition";
import NewsLabel from "@/components/NewsLabel.vue";

export default {
    name: "MdcAccordionWrapper",
    components: {NewsLabel},
    props: {
        index: {
            type: Number,
            required: true
        },
        label: {
            type: String,
            default: null
        },
        sublabel: {
            type: String,
            default: null
        },
        itemid: {
            type: String,
            default: null
        },
        newslabel: {
            type: String,
            default: null
        },
        icon: {
            type: String,
            default: null
        },
        image: {
            type: String,
            default: null
        },
        opened: {
            type: Boolean,
            required: true
        }
    },
    setup(props, {emit}) {

        // Register props
        const {
            label,
            sublabel,
            itemid,
            newslabel,
            icon,
            image
        } = toRefs(props)

        // Register target elements
        const root = ref();
        const target = ref();

        // Register prop opened change and action
        const state = computed(() => {
            if (target.value) {
                const t = target.value;
                if (props.opened) {
                    t.style.height = t.children[0].offsetHeight + "px";
                    root.value.scrollIntoView({behavior: "smooth"});
                    waitForElementTransition(t).then(() => {
                        t.style.height = null;
                    });
                } else {
                    t.style.height = t.children[0].offsetHeight + "px";
                    setTimeout(() => {
                        t.style.height = null;
                    }, 10)
                }
            }
            return {
                opened: props.opened,
                closed: !props.opened
            };
        })

        // Toggle the state
        const toggleAction = () => {
            emit("toggle", props.index);
        }

        return {
            root,
            target,
            state,
            label,
            sublabel,
            itemid,
            newslabel,
            icon,
            image,
            toggleAction
        }
    }
}
</script>
